import { frontendURL } from '../../../helper/URLHelper';

const KanbanBoard = () => import('./KanbanBoard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban',
    component: KanbanBoard,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
